var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"right":"65px","bottom":"8rem"},attrs:{"fab":"","dark":"","fixed":"","bottom":"","color":_vm.color},on:{"click":_vm.toTop}},[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v("mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }